import { configureStore } from '@reduxjs/toolkit'
import userReducer from '../routing/fetchingfunction/user/user.reducer'
import infoReducer from '../routing/fetchingfunction/info/info.reducer'
import dashboardReducer from '../routing/fetchingfunction/dashboard/dashboard.reducer'
import jobReducer from '../routing/fetchingfunction/job/job.reducer'
import quizReducer from '../routing/fetchingfunction/quiz/quiz.reducer'
import jobSearchReducer from '../routing/fetchingfunction/jobSearch/jobSearch.reducer'
import classBannerSearchReducer from '../routing/fetchingfunction/classBannerSearch/classBannerSearch.reducer'
import classBannerBookingReducer from '../routing/fetchingfunction/classBannerBooking/classBannerBooking.reducer'

export const store = configureStore({
  reducer: {
    user: userReducer,
    info: infoReducer,
    dashboard: dashboardReducer,
    job: jobReducer,
    quiz: quizReducer,
    jobSearch: jobSearchReducer,
    classBannerSearch: classBannerSearchReducer,
    classBannerBooking: classBannerBookingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export default store
